import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { SWITCH_SIZES } from "../types";

const useStyles = () => {
    const { gray900, textDisabled } = colors;

    const options = {
        [SWITCH_SIZES.Small]: {
            width: 30,
            height: 16,
            thumb: 14,
            translateX: 14,
            iconSize: null
        },
        [SWITCH_SIZES.Medium]: {
            width: 36,
            height: 20,
            thumb: 18,
            translateX: 16,
            iconSize: 20
        },
        [SWITCH_SIZES.Large]: {
            width: 48,
            height: 24,
            thumb: 22,
            translateX: 24,
            iconSize: 24
        }
    };

    const getLabelStyles = (isDisabled: boolean | undefined): CSSObject => ({
        color: isDisabled ? textDisabled : gray900,
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.1px"
    });

    return { options, getLabelStyles };
};

export { useStyles };
